// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__lMsxJ","accordionHeader":"Accordion_accordionHeader__2K91b","accordionContent":"Accordion_accordionContent__5ibqP"};